export default __webpack_public_path__ + "src/assets/leap.2f31062518f2d9f5063c293e6294c1c1.svg";